import React from "react";
import SectionHeading from "../../SectionHeading";
import Spacing from "../../Spacing";
import IconBoxStyle6 from "../../IconBox/IconBoxStyle6";

const missions = [
  {
    title: "Our Mission",
    desc: "To empower clinicians with scientifically validated, rational, and safe therapeutic solutions that improve outcomes in chronic neurological, psychiatric and lifestyle-related diseases.",
  },
  {
    title: "Our Vision",
    desc: "To become a trusted and respected healthcare partner by delivering integrity-driven innovation, continuous medical education, and patient-centric care.",
  },
];

const values = [
  {
    icon: "science",
    title: "Science before marketing",
  },
  {
    icon: "ethics",
    title: "Ethical & transparent communication",
  },
  {
    icon: "formulation",
    title: "Rational formulations with justified dosages",
  },
  {
    icon: "safety",
    title: "Long-term patient safety and compliance",
  },
  {
    icon: "judgement",
    title: "Respect for clinical judgement",
  },
];
const Icons = {
  science: (
    <svg
      className="cs_icon_svg"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="22" cy="22" r="6" stroke="currentColor" strokeWidth="2" />
      <ellipse
        cx="22"
        cy="22"
        rx="18"
        ry="8"
        stroke="currentColor"
        strokeWidth="1.8"
        fill="none"
      />
      <ellipse
        cx="22"
        cy="22"
        rx="18"
        ry="8"
        stroke="currentColor"
        strokeWidth="1.8"
        fill="none"
        transform="rotate(60 22 22)"
      />
      <ellipse
        cx="22"
        cy="22"
        rx="18"
        ry="8"
        stroke="currentColor"
        strokeWidth="1.8"
        fill="none"
        transform="rotate(120 22 22)"
      />
      <circle cx="22" cy="22" r="2.5" fill="currentColor" />
    </svg>
  ),
  ethics: (
    <svg
      className="cs_icon_svg"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 6C22 6 10 10 10 20C10 30 16 38 22 38C28 38 34 30 34 20C34 10 22 6 22 6Z"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
      <path
        d="M16 22L20 26L28 18"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 6V14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.6"
      />
    </svg>
  ),
  formulation: (
    <svg
      className="cs_icon_svg"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="11"
        y="7"
        width="22"
        height="30"
        rx="3"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M16 16H28"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M16 22H28"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M16 28H22"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle
        cx="30"
        cy="30"
        r="5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path
        d="M28 30H32M30 28V32"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  ),
  safety: (
    <svg
      className="cs_icon_svg"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 5L8 11V22C8 30.5 14.5 37.5 22 39C29.5 37.5 36 30.5 36 22V11L22 5Z"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
      <path
        d="M16 22L20 26L28 18"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="31"
        cy="13"
        r="5"
        fill="currentColor"
        fillOpacity="0.2"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M31 11V15M29 13H33"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  judgement: (
    <svg
      className="cs_icon_svg"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 10C18 10 14 13.5 14 18C14 22.5 18 25 22 30C26 25 30 22.5 30 18C30 13.5 26 10 22 10Z"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
      <path
        d="M14 34H30"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M22 30V34"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle
        cx="22"
        cy="18"
        r="3.5"
        fill="currentColor"
        fillOpacity="0.4"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  ),
};

function ConnectorSVG() {
  const W = 900,
    H = 48;
  const pts = [0.1, 0.3, 0.5, 0.7, 0.9].map((p) => p * W);
  const topY = 8,
    bottomY = 40;

  return (
    <svg
      className="cs_connector_svg"
      viewBox={`0 0 ${W} ${H}`}
      preserveAspectRatio="none"
    >
      <line x1={pts[0]} y1={topY} x2={pts[4]} y2={topY} />
      <line
        className="animated-dash"
        x1={pts[0]}
        y1={topY}
        x2={pts[4]}
        y2={topY}
      />
      {pts.map((x, i) => (
        <line key={i} x1={x} y1={topY} x2={x} y2={bottomY} />
      ))}
    </svg>
  );
}

export default function FeaturesSectionStyle2({ sectionTitle, imgUrl, data }) {
  return (
    <section className="cs_mv_exact">
      {/* Top Image */}
      <div className="cs_mv_image">
        <img src={imgUrl} alt="mission vision" />
      </div>

      <div className="container">
        {/* Mission Vision */}
        <div className="row cs_mv_row">
          {missions?.map((item, index) => (
            <div className="col-md-6" key={index}>
              <div className="cs_mv_box">
                <h4>{item.title}</h4>
                <p className="about_text">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Core Values */}
      {/* <div className="cs_core_section">
        <div className="container">
          <h3>Our Core Values</h3>

          <div className="cs_values_wrapper">
            <div className="cs_horizontal_line"></div>

            {values?.map((item, index) => (
              <div className="cs_value" key={index}>
                <div className="cs_vertical_line"></div>

                <div className="cs_icon_circle">
                  <img src={item.icon} alt="" />
                </div>

                <p>{item.title}</p>
              </div>
            ))}
          </div>
        </div>
      </div> */}
      {/* <section className="cs_core_values_pro">
        <div className="container">
          <h2 className="cs_title">Our Core Values</h2>

          <div className="cs_values_wrap">
            <div className="cs_top_connectors">
              <span className="step step1"></span>
              <span className="step step2"></span>
              <span className="step step3"></span>
              <span className="step step4"></span>
            </div>

            {values.map((item, index) => (
              <div className="cs_value_item" key={index}>
                <div className="cs_icon_wrap">
                  <div className="cs_ring"></div>
                  <div className="cs_icon">
                    <img src={item.icon} alt={item.title} />
                  </div>
                </div>

                <div className="cs_arrow"></div>

                <p>{item.title}</p>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      <section className="cs_core_values_pro">
        {/* Background layers */}
        <div className="cs_grid_lines" />
        {/* <div className="cs_orb cs_orb1" />
        <div className="cs_orb cs_orb2" /> */}

        <div className="container">
          <h2 className="cs_title">
            <span>Our Core Values</span>
          </h2>

          <div style={{ position: "relative" }}>
            {/* Connector lines */}
            <div className="cs_connector_system">
              <ConnectorSVG />
            </div>

            {/* Values */}
            <div className="cs_values_wrap">
              {values.map((item, i) => (
                <div className="cs_value_item" key={i}>
                  <div className="cs_icon_wrap">
                    <div className="cs_ring_spin" />
                    <div className="cs_ring_outer" />
                    <div className="cs_circle_bg" />
                    {Icons[item.icon]}
                  </div>

                  <div className="cs_arrow_wrap">
                    <svg
                      className="cs_arrow_svg"
                      width="18"
                      height="14"
                      viewBox="0 0 18 14"
                    >
                      <path d="M9 14L0.339746 0.5L17.6603 0.5L9 14Z" />
                    </svg>
                  </div>

                <p className="cs_value_label">
                    {(item.title || item.label || "").split("\n").map((line, j) => (
                      <span key={j}>{line}<br /></span>
                    ))}
                  </p>


                  <div className="cs_num_badge">0{i + 1}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="cs_bottom_accent">
            <div className="cs_accent_line" />
          </div>
        </div>
      </section>
    </section>
  );
}
